<script lang="ts">import BodyScrollLocker from '../../shared/BodyScrollLocker/BodyScrollLocker.svelte';
import Dropdown from './Dropdown/Dropdown.svelte';
import HomeLink from '../../shared/HomeLink/HomeLink.svelte';
import MenuToggle from './MenuToggle/MenuToggle.svelte';
import BackButton from '../../shared/BackButton/BackButton.svelte';
import { getSearchOptionsStore } from '../../../Search/SearchProvider.svelte';
import { mobileNavStateStore } from '../../../../js-v2/stores/mobile-nav-stores';
import { mobileCtaSubnavMenuStateStore } from '../../../../js-v2/stores/mobile-cta-subnav-stores';
import { mobileNavIsSticky } from '../../../../js-v2/stores/mobile-nav-sticky-store';
import { DROPDOWN_ENTER_DURATION } from '../../../../js-v2/constants';
const { id = '', homeLink = undefined, primaryNavItems = [], secondaryNavItems = [], cart = undefined, } = $props();
const searchOptions = getSearchOptionsStore();
const renderDropdown = $derived(primaryNavItems.length > 0 || secondaryNavItems.length > 0 || cart || $searchOptions.isEnabled);
let mobileNavHeight = $state();
</script>

<div class="shim" aria-hidden="true" style:height={$mobileNavIsSticky ? `${mobileNavHeight}px` : '0px'}></div>
<div
  class="MobileNav"
  class:globalNavIsSticky={$mobileNavIsSticky}
  data-global-nav-mobile-v2
  data-entry-id={id}
  bind:offsetHeight={mobileNavHeight}
>
  <div class="left-slot">
    <div class="home-link-wrapper" class:active={!$mobileNavStateStore.isOpen}>
      <HomeLink
        id={homeLink?.contentfulEntryId}
        title={homeLink?.props?.title}
        logo={homeLink?.props?.logo}
        url={homeLink?.props?.url}
      />
    </div>
    <BackButton isActive={$mobileNavStateStore.activeContentStack.length > 0} clickTouchFn={mobileNavStateStore.pop} />
  </div>
  <div class="right-slot">
    {#if renderDropdown}
      <div class="__menu_toggle_focus" aria-hidden="true" tabindex="-1"></div>
      <MenuToggle />
    {/if}
  </div>

  {#if renderDropdown}
    <Dropdown {primaryNavItems} {secondaryNavItems} {mobileNavHeight} {cart} />
  {/if}
</div>

<!-- pass in DROPDOWN_ENTER_DURATION to delayLockAfter, the value is the same as $duration-medium-in -->
<BodyScrollLocker
  shouldLock={$mobileCtaSubnavMenuStateStore.isOpen || $mobileNavStateStore.isOpen}
  delayLockAfter={DROPDOWN_ENTER_DURATION}
/>

<style>@keyframes fade-in-slide-from-top {
  from {
    opacity: 0;
    transform: translateX(0) translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes fade-in-slide-from-left {
  from {
    opacity: 0;
    transform: translateX(-4px) translateY(0);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}
@keyframes slide-down {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(0);
  }
}
/**
We use rem units for media queries to promote accessible layouts. By utilizing rem units, the computed values in media queries are determined by the user's browser-defined font size rather than our global 'font-size: 62.5%' reset. This approach ensures that our design adapts to individual user settings, enhancing accessibility. 
*/
.shim {
  background-color: var(--color-background, var(--color-neutral-1000, #fff));
}

.MobileNav {
  padding-left: 22px;
  padding-right: 22px;
  box-sizing: border-box;
  position: relative;
  min-width: 320px;
  z-index: 3;
  padding-top: 4px;
  padding-bottom: 4px;
  background-color: var(--color-background, var(--color-neutral-1000, #fff));
  color: var(--color-text, var(--color-neutral-000, #000000));
  display: flex;
}
@media (min-width: 105rem) {
  .MobileNav {
    --nav-outer-gutter-base: calc(var(--space-10) / 2);
    --nav-outer-gutter: max(var(--nav-outer-gutter-base), var(--dynamic-gutter));
    padding-left: calc(22px + var(--nav-outer-gutter)) !important;
    padding-right: calc(22px + var(--nav-outer-gutter)) !important;
  }
}
.MobileNav.globalNavIsSticky {
  animation: slide-down 100ms ease-out forwards;
  position: fixed;
  top: 0;
  width: 100%;
}
@media (min-width: 64rem) {
  .MobileNav {
    display: none;
  }
}
.MobileNav .left-slot,
.MobileNav .right-slot {
  display: flex;
  align-items: center;
  width: 100%;
  flex: 0 1 auto;
}
.MobileNav .left-slot {
  justify-content: flex-start;
}
.MobileNav .left-slot .home-link-wrapper {
  display: none;
}
.MobileNav .left-slot .home-link-wrapper.active {
  display: block;
}
.MobileNav .right-slot {
  justify-content: flex-end;
}</style>
